module.exports = __webpack_public_path__ + "img/img_deposit_banner03.62051809.png";